import React from "react"
import TopTitle from "@components/TopTitle"

const IntroDescription = props => {
  return (
    <div className={props.className + " col-12"}>
      <div className="text-center">
        <h3>
          <TopTitle content="QUESTIONS?" />
          <div className="proxima-nova--extra-bold text-secondary fs-30pt fs-lg-40pt fs-xl-42pt">
            WE HAVE THE ANSWERS
          </div>
        </h3>
      </div>
    </div>
  )
}

export default IntroDescription
